<template>
  <el-container class="generalAlarm">
    <!-- 告警列表 -->
    <el-card class="tabs-card">
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="getFindByConditionAxio"
          :params="tableParams"
          :paging="alarmTablestatus == '1'"
          :selectMethod="statusValue"
          :showLoading="false"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #alarmName="{ row }">
            <div class="table-role-alarmName" @click="clickAlarmDetial(row)">
              {{ row.alarmName }}
            </div>
          </template>
          <template #alarmTime="{ row }">
            <div class="table-role">
              {{
                moment(parseInt(row.alarmTime)).format("YYYY-MM-DD HH:mm:ss")
              }}
            </div>
          </template>
          <template #alarmStatus="{ row }">
            <div class="table-role">
              {{
                row.alarmStatus == 0
                  ? "未处理"
                  : row.alarmStatus == 1
                  ? "已处理"
                  : "误报"
              }}
            </div>
          </template>

          <template #role="{ row }">
            <div class="table-role">
              <h-button
                @click="handlebtn(row)"
                type="primary"
                :disabled="row.alarmStatus != 0"
                style="width: 80px"
                >{{ row.alarmStatus != 0 ? "已处理" : "处理" }}</h-button
              >
              <!-- <h-button type="primary" @click="lingagebtn(row)"
                >联动信息</h-button
              > -->
              <!-- <h-button type="primary">工单</h-button> -->
            </div>
          </template>
        </h-table>
      </div>
    </el-card>
    <alarmDetailDialog
      v-if="alarmDetailVisible"
      v-model:visible="alarmDetailVisible"
      :itemInfo="alarmDetailItem"
    ></alarmDetailDialog>
    <handleDialog
      v-model="formVisible"
      :tableData="handlelItem"
      @refresh="refreshTable"
    ></handleDialog>
    <serverRestart v-model="clickVisible"></serverRestart>
    <linkageInformation v-model="linkageVisible"></linkageInformation>
  </el-container>
</template>
<script>
// import {  } from "@/api/system";
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  ref,
  computed,
  onMounted,
  onUnmounted,
} from "vue";
import { ElMessageBox } from "element-plus";
import moment from "moment";
import util from "@util/js";
// import { queryUserList, infoQuery } from "@/api/realPopulation/realPopulation";
import { getFindByCondition } from "@/api/alarmCenter/alarmCenter.js";
import handleDialog from "./handleDialog";
import serverRestart from "../alarmLog/generalAlarm/components/serverRestart";
import linkageInformation from "../alarmLog/generalAlarm/components/linkageInformation";

import _ from "lodash";
export default defineComponent({
  name: "generalAlarm",
  components: { handleDialog, serverRestart, linkageInformation },
  props: {
    tableParams: {
      type: Object,
      defaule: () => {},
    },
    alarmTablestatus: {
      type: String,
      defaule: "",
    },
  },
  setup(props, context) {
    const state = reactive({
      userFormData: {},
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      clickVisible: false,
      moveVisible: false,
      linkageVisible: false,
      alarmDetailVisible: false, //告警详情
      alarmDetailItem: false, //告警详情数据
      handlelItem: [], //处理行数据
      currentPage: "",
      queryTime: null,
    });
    const refData = toRefs(state);
    const tableRef = ref(null);
    const columns = computed(() => {
      if (props.alarmTablestatus == "0") {
        return [
          { type: "index" },
          {
            label: "状态",
            slot: "alarmStatus",
          },
          {
            label: "告警等级",
            prop: "alarmLevel", // sex
          },
          {
            label: "告警标题",
            slot: "alarmName",
          },
          {
            label: "告警类型",
            prop: "alarmSourceName", // nation
          },
          {
            label: "告警源类型",
            prop: "alarmSourceName", // nation
          },
          {
            label: "告警时间",
            slot: "alarmTime",
          },
          {
            label: "告警地点",
            prop: "deviceName",
          },
          {
            label: "告警设备",
            prop: "deviceName",
          },
        ];
      } else if (props.alarmTablestatus == "1") {
        return [
          { type: "selection" },
          { type: "index" },
          {
            label: "状态",
            slot: "alarmStatus",
          },
          {
            label: "告警等级",
            slot: "alarmLevel", // sex
          },
          {
            label: "告警标题",
            slot: "alarmName",
          },
          {
            label: "告警类型",
            prop: "alarmSourceName", // nation
          },
          {
            label: "告警源类型",
            prop: "alarmSourceName", // nation
          },
          {
            label: "告警时间",
            slot: "alarmTime",
          },
          {
            label: "告警地点",
            prop: "deviceName",
          },
          {
            label: "告警设备",
            prop: "deviceName",
          },
          {
            // type: "operate",
            label: "操作",
            width: "250px",
            slot: "role",
            // operates: [
            //   { name: "处理", emitKey: "edit" },
            //   { name: "联动信息", emitKey: "edit" },
            //   { name: "工单", emitKey: "edit" }
            // ]
          },
        ];
      }
    });
    const getFindByConditionAxio = async () => {
      const tableParams = _.cloneDeep(props.tableParams);
      const paramsFace = { ...tableParams, type: "2" };
      const paramsCar = { ...tableParams, type: "1" };
      const resFace = await getFindByCondition(paramsFace);
      const resCar = await getFindByCondition(paramsCar);
      const arr = [...resFace.page.list, ...resCar.page.list];
      arr.sort((a, b) => {
        let atime = Number(a.alarmTime);
        let btime = Number(b.alarmTime);
        return atime > btime ? 1 : -1;
      });
      return {
        page: {
          list: arr.splice(0, 10),
        },
      };
    };
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    const hzTableSelect = (value) => {
      context.emit("tableSelect", value);
      state.handlelItem = value;
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        // state.userFormData.roleIdList = row.roleList.map(item => item.roleId);
        nextTick(() => {});
      } else if (emitKey === "info") {
        // 详情
        state.formStatus = 3; // 把表单设置为查看状态
        state.userFormData = _.cloneDeep(row);
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {},
          () => {}
        );
      }
    };

    //打开告警详情弹窗
    const clickAlarmDetial = (item) => {
      state.alarmDetailVisible = true;
      state.alarmDetailItem = item;
    };
    // 处理
    const handlebtn = (item) => {
      state.formVisible = true;
      if (item) {
        //单个处理
        tableRef.value && tableRef.value.clearSelection();
        state.handlelItem = [];
        context.emit("tableSelect", []);
        nextTick(() => {
          state.handlelItem = [item];
        });
      } else {
        //批量处理
        state.handlelItem = state.handlelItem;
      }
    };
    // 服务器重启
    const serverBtn = (item) => {
      state.clickVisible = true;
      console.log(
        "🚀 ~ file: generalAlarm.vue ~ line 297 ~ serverBtn ~ item",
        item
      );
    };
    // 联动信息
    const lingagebtn = (item) => {
      console.log(
        "🚀 ~ file: generalarmList.vue ~ line 259 ~ lingagebtn ~ item",
        item
      );
      state.linkageVisible = true;
    };
    const statusValue = (row) => {
      if (row && row.alarmStatus != "0") {
        return false;
      } else {
        return true;
      }
    };
    onMounted(() => {
      if (props.alarmTablestatus == "0") {
        state.queryTime = setInterval(() => {
          refreshTable();
        }, 60 * 1000);
      }
    });
    onUnmounted(() => {
      clearInterval(state.queryTime);
    });
    return {
      ...refData,
      handlebtn,
      moment,
      serverBtn,
      hzTableSelect,
      lingagebtn,
      handleClick,
      getFindByCondition,
      getFindByConditionAxio,
      tableRef,
      clickAlarmDetial,
      refreshTable,
      columns,
      statusValue,
    };
  },
});
</script>
<style lang="scss" scoped>
.generalAlarm {
  width: 100%;
  height: 100%;
  .organTransfer {
    height: 60vh;
  }
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    // margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      .table-role {
        color: #294a7c;
        cursor: pointer;
        span {
          border-bottom: 1px solid;
        }
      }
      .table-role-alarmName {
        color: #294a7c;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .colorblue {
      color: #294a7c;
      cursor: pointer;
    }
  }
}
</style>
